<template>
    <div class="w-full">
        <label for="year">Выберите год:</label>
        <select v-model="selectedYear">
            <option v-for="year in availableYears" :key="year" :value="year">
                {{ year }}
            </option>
        </select>

        <canvas ref="chartCanvas"></canvas>
    </div>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import Chart from 'chart.js/auto';

const props = defineProps({
    mentionsOverTime: Object,
});

const chartCanvas = ref(null);
const chartInstance = ref(null);
const selectedYear = ref("2025");

const availableYears = computed(() => {
    return [...new Set(props.mentionsOverTime.labels.map(label => label.split("-")[0]))];
});

const filteredData = computed(() => {
    return props.mentionsOverTime.labels
        .map((label, index) => ({
            week: label,
            mentions: props.mentionsOverTime.data[index],
        }))
        .filter((item) => item.week.startsWith(selectedYear.value));
});

const renderChart = () => {
    if (chartInstance.value) {
        chartInstance.value.destroy();
    }
    chartInstance.value = new Chart(chartCanvas.value, {
        type: "line",
        data: {
            labels: filteredData.value.map((item) => item.week),
            datasets: [
                {
                    label: "Mentions",
                    data: filteredData.value.map((item) => item.mentions),
                    borderColor: "blue",
                    borderWidth: 2,
                },
            ],
        },
    });
};

watch([filteredData, selectedYear], renderChart, { immediate: true });

onMounted(renderChart);
</script>